import lifetouchCodeFormDirective from 'html/claim/lifetouch-code-form-directive.html';
import App from 'app/app.js';

function LtLifetouchCodeFormDirective() {
  return {
    restrict: 'E',
    scope: {
      lifetouchCode: '<',
      portraitId: '<',
      pictureDayId: '<'
    },
    template: lifetouchCodeFormDirective,
    controller: 'LtLifetouchCodeFormCtrl',
    controllerAs: 'lifetouchCodeForm'
  };
}

App.directive('ltLifetouchCodeForm', [LtLifetouchCodeFormDirective]);
